const faqs = [
  {
    question: "Does Hawaii have its own passport agency?",
    answer:
      "No, Hawaii does not have a regional passport agency. The nearest agencies are in Los Angeles and San Francisco on the mainland. This makes using a registered courier service like Fast Passport Center the most practical option for Hawaii travelers who need expedited or emergency passport processing.",
  },
  {
    question: "How fast can I get a passport in Hawaii?",
    answer:
      "With Fast Passport Center's courier service, Hawaii travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Because Hawaii is isolated from the mainland, using a courier is significantly faster than routine mail-in processing.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Hawaii?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office or county clerk). Renewals for adults can usually be done by mail without an in-person visit. Hawaii has acceptance facilities on all major islands.",
  },
  {
    question: "Which Hawaii airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Hawaii international airports include Honolulu (HNL), Kahului (OGG), Kona (KOA), Lihue (LIH), and Hilo (ITO). Most Hawaii residents fly through HNL for international travel.",
  },
  {
    question: "Can I get a passport on the same island where I live?",
    answer:
      "Yes. Fast Passport Center serves all Hawaiian islands remotely. You can apply from Oahu, Maui, the Big Island, Kauai, Molokai, or Lanai without leaving your island. We handle document pickup, courier delivery to the U.S. Department of State, and return shipping directly to your Hawaii address.",
  },
  {
    question: "What if my flight is in less than 14 days and I am in Hawaii?",
    answer:
      "For travel within 14 days, you qualify for emergency passport processing. Since Hawaii has no regional passport agency, your best options are: (1) Use Fast Passport Center's 24-hour or 3-day emergency courier service, or (2) Fly to the Los Angeles or San Francisco passport agency with proof of travel. The courier option is almost always faster and more cost-effective.",
  },
];

export { faqs };

export default function HawaiiFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Hawaii Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the Hawaiian Islands.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}